import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { CountrySelect } from './CountrySelect'

/** ISO 3166-2 subdivisions that carry their own housing law. World facts, like the country list. */
export const JURISDICTION_SUBDIVISIONS = ['GB-ENG', 'GB-SCT', 'GB-WLS', 'GB-NIR'] as const

interface JurisdictionSelectProps {
  value: string
  onValueChange: (value: string) => void
  className?: string
  disabled?: boolean
  includeAll?: boolean
  placeholder?: string
  'data-testid'?: string
}

/** A country, or a subdivision of the United Kingdom: what a rule or an organization is judged under. */
export function JurisdictionSelect({ 'data-testid': testId, ...props }: JurisdictionSelectProps) {
  const { t } = useTranslation('common')
  const extraOptions = useMemo(
    () => JURISDICTION_SUBDIVISIONS.map(code => ({ value: code, label: `🇬🇧 ${t(`jurisdiction_subdivisions.${code}`)}` })),
    [t],
  )
  return <CountrySelect {...props} extraOptions={extraOptions} data-testid={testId} />
}
